import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import DriverTablet from './driver-tablet.jsx';

export default class DriversTablets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers_tablet_accounts:  null,
      isLoading: false,
      url: props.url || '/api/v1/portal/drivers/tablets',
    };


    this.getDriversTablets();
  }

  getDriversTablets() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driversExcessAccountsJson) => {
        this.setState({
          drivers_tablet_accounts: driversExcessAccountsJson,
          isLoading: false,
        });
      });
    });
  }

  render() {
    let DriversTablets = [];

    if (this.state.drivers_tablet_accounts &&
        this.state.drivers_tablet_accounts.length > 0) {
        this.state.drivers_tablet_accounts.forEach(
          function(i) {
            DriversTablets.push(
              <DriverTablet
                key={'drivers-tablets-'+i.id}
                data={i}
              />);
          }
       );
    }
    return (
      <div>
      {
        this.state.isLoading ?
        (<div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div>) :
          <div>{DriversTablets}</div>
      }
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-drivers-tablets')) {
  ReactDOM.render(
    <DriversTablets
      url = {"/api/v1/portal/drivers/tablets"}
      message_if_none = 'Excessses not found or available for viewing.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-tablets'
    )
  );
}
